import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png';

// Font registration
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});

// Utility to chunk array
function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}



const CancelledStudents = ({ data }) => {
  const rowChunks = chunkArray(data.data, 30); // Split data into chunks of 30 rows

  console.log(data, "RTT")

  const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


const formattedStartDate = formatDate(data.startdate) || '';
const formattedEndDate = formatDate(data.enddate) || '';

  return (
    <Document>
      {rowChunks.map((chunk, chunkIdx) => (
        <Page
          key={chunkIdx}
          size="A4"
          style={{ padding: 30, fontSize: 10 }}
        >
          {/* Logo */}
          <View style={{ justifyContent: "flex-start" }}>
            <Image source={sitlogo} style={{ width: 70 }} />
          </View>

          {/* Title */}
          <View
            style={{
              width: '100%',
              height: "18px",
              border: '1px solid black',
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>
              Cancelled Student Report (From date {formattedStartDate} To {formattedEndDate})
            </Text>
          </View>

          {/* Table Header */}
          <View style={{ width: "100%", height: "2.7%", border: "1px solid black", flexDirection: "row" }}>
            <View style={{ width: "4%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>No.</Text>
            </View>
            <View style={{ width: "24%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Name</Text>
            </View>
            <View style={{ width: "15%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Mobile</Text>
            </View>
            <View style={{ width: "37%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Email</Text>
            </View>
            <View style={{ width: "9%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Batch</Text>
            </View>
            <View style={{ width: "11%", justifyContent: "center", alignItems: "center", paddingTop: 2 }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Date</Text>
            </View>
          </View>

          {/* Table Rows */}
          {chunk.map((row, idx) => (
            <View
              key={idx}
              style={{
                width: "100%",
                height: "2.7%",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                borderLeft: "1px solid black",
                flexDirection: "row",
              }}
            >
              <View style={{ width: "4%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{idx + 1}</Text>
              </View>
              <View style={{ width: "24%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{row.Student_Name}</Text>
              </View>
              <View style={{ width: "15%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{row.Present_Mobile}</Text>
              </View>
              <View style={{ width: "37%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{row.Email}</Text>
              </View>
              <View style={{ width: "9%", justifyContent: "center", alignItems: "center", paddingTop: 2, borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{row.Batch_code}</Text>
              </View>
              <View style={{ width: "11%", justifyContent: "center", alignItems: "center", paddingTop: 2 }}>
                <Text style={{ fontSize: 8, fontFamily: 'Poppins' }}>{row.cancel_date}</Text>
              </View>
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default CancelledStudents;